import { SERVICE_TYPE } from "@typings/globals";
import { LOADING_STATE } from "@typings/reduxThunkActions";

import { ResultsPosition } from "../Select";

export interface ZipCodeFieldProps {
  placeholder: string;
  resultsPosition?: ResultsPosition;
  drawerHeader?: React.ReactNode;
}

export interface SuggestionResponse {
  city: string;
  zip: string;
  hideCityName: boolean;
}

export interface Suggestion {
  value: string;
  label: string;
}

export enum ZIP_CODE_ACTION {
  FETCH_SUGGESTIONS = "FETCH_SUGGESTIONS",
  SET_SUGGESTIONS = "SET_SUGGESTIONS",
  FAILED_SUGGESTIONS = "FAILED_SUGGESTIONS",
}

export interface ZipCodeAction {
  type: ZIP_CODE_ACTION;
  payload?: Suggestion[];
}

export interface ZipCodeState {
  status: LOADING_STATE;
  suggestions: Suggestion[];
}

export interface ZipCodeSettings {
  drawerId: string;
}

export interface FetchSuggestionsProps {
  query: string;
  serviceType: SERVICE_TYPE;
  signal: AbortSignal;
}

export interface GetSuggestionsProps {
  query: string;
  serviceType: SERVICE_TYPE;
  dispatch: React.Dispatch<ZipCodeAction>;
}
